import { render, staticRenderFns } from "./ProcessedLargeFiles.vue?vue&type=template&id=5b210a5a&"
import script from "./ProcessedLargeFiles.vue?vue&type=script&lang=ts&"
export * from "./ProcessedLargeFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports